<template>
    <section class="filter">
        <section class="top" @click="changeChannel($event)">
            <span data-channel="1" :class="{ 'active': channel === '1' }">{{ channelData['1'].name + ' ' + channelData['1'].score + '分'}}</span>
            <span data-channel="2" :class="{ 'active': channel === '2' }" v-if="false">{{ channelData['2'].name + ' ' + channelData['2'].score + '分'}}</span>
        </section>
        <section class="tags" @click="changeTag($event)">
            <span :class="tagSelected === '全部' ? 'active' : ''" data-tag="全部">全部</span>
            <span :class="tagSelected === '30天未回复' ? 'active' : ''" data-tag="30天未回复">30天未回复</span>
            <span :class="tagSelected === '有内容评价' ? 'active' : ''" data-tag="有内容评价" v-show="channel === '1'">有内容评价</span>
            <span v-for="item in channelData[this.channel].tags" :data-tag="item.tag" :class="{ 'bad': item.isPositive === 0, 'active': item.tag === tagSelected }">{{ item.tag + ' ' + item.count }}</span>
        </section>
        <section class="filter-content" v-show="showDateAndStarFilter">
            <section>
                <label>评价日期</label>
                <span v-for="item in commentDate" :class="commentDateSelected === item.value ? 'active' : ''" :value="item.value" @click="selectCommentDate(item.value)">{{ item.name }}</span>
                <span style="width: 185px;" @click="selectCommentDate('range')" :class="commentDateSelected === 'range' ? 'active' : ''">
                    <v-datepicker :options='dateInputOption' v-model="commentDateRange" placeholder="自定时段"></v-datepicker>
                </span>
            </section>
            <section>
                <label>评价星级</label>
                <span v-for="item in commentStar" :class="commentStarSelected.indexOf(item.value) !== -1 ? 'active' : ''" :value="item.value" @click="selectCommentStar(item.value)">{{ item.name }}</span>
            </section>
        </section>
    </section>
</template>

<style lang="postcss">
    :root {
        --blueColor: #2A99F1;
    }
    .filter {
        border-radius: 2px;
        overflow: hidden;
        & .top {
            margin-top: 10px;
            height: 46px;
            line-height: 46px;
            background-color: #FFF;
            padding: 0 30px;
            border-bottom: 1px solid #F2F3F8;
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            & > span {
                height: 100%;
                display: inline-block;
                box-sizing: border-box;
                cursor: pointer;
                &:nth-child(n+2) {
                    margin-left: 30px;
                }
                &.active {
                    color: var(--blueColor);
                    border-bottom: 3px solid var(--blueColor);
                }
            }
        }
        & .tags {
            padding: 7px 30px 15px 30px;
            background-color: #FFF;
            border-bottom: 1px solid #F2F3F8;
            margin-top: 0;
            & > span {
                display: inline-block;
                height: 30px;
                line-height: 30px;
                border: 1px solid #C5C9CF;
                border-radius: 50px;
                padding: 0 17px;
                cursor: pointer;
                margin-right: 10px;
                margin-top: 8px;
                &.bad {
                    color: #8F9192;
                    border: 1px solid #C5C9CF;
                }
                &.active {
                    color: #FFF;
                    background-color: #36A7F4;
                    border: 1px solid #36A7F4;
                }
            }
        }
        & .filter-content {
            background-color: #FCFCFC;
            padding: 15px 30px;
            & > section {
                height: 30px;
                line-height: 30px;
                &:nth-child(n+2) {
                    margin-top: 15px;
                }
                & > label {
                    width: 80px;
                    vertical-align: top;
                }
                & > span {
                    width: 105px;
                    height: 100%;
                    border: 1px solid #C5C9CF;
                    border-radius: 2px;
                    display: inline-block;
                    text-align: center;
                    overflow: hidden;
                    cursor: pointer;
                    &:nth-of-type(n+2){
                        margin-left: 10px;
                    }
                    &.active {
                        color: var(--blueColor);
                        border: 1px solid var(--blueColor);
                    }
                    & .flatpickr-input {
                        width: 100%;
                        height: 100%;
                        border: 0;
                        text-align: center;
                        background-color: transparent;
                        &::-webkit-input-placeholder {
                            color: #1f2d3d;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import { commentDate, commentStar } from 'data/comment-data'
    import Comment from 'api/comment'
    import Moment from 'moment'
    import { eventBus } from 'helpers/index'

    export default {
        data () {
            return {
                channel: '1', // 当前展示平台，1 美团 2 点评
                channelData: {
                    '1': {
                        name: '美团',
                        score: '',
                        tags: []
                    },
                    '2': {
                        name: '点评',
                        score: '',
                        tags: []
                    }
                },
                tagSelected: '全部',
                showDateAndStarFilter: true, // 是否显示日期和星级筛选
                dateInputOption: { // 选择日期配置
                    'mode': 'range',
                    'maxDate': Moment().format('YYYY-MM-DD'),
                    'minDate': Moment().subtract(Moment.duration(90, 'd')).format('YYYY-MM-DD'),
                    'onClose': function (value) {
                        if (Array.isArray(value) && value.length === 2) {
                            this.commentDateRange = Moment(value[0]).format('YYYY-MM-DD') + ' ~ ' +
                                Moment(value[1]).format('YYYY-MM-DD')
                            this.getCommentData()
                        }
                    }.bind(this)
                },
                commentDate: commentDate, // 评价日期
                commentStar: commentStar, // 评价星级
                commentDateSelected: '', // 当前选中的日期，值为'0' '1' '2' '3' 'range'
                commentStarSelected: ['1', '2', '3', '4', '5'], // 当前选中的星级
                commentDateRange: '' // 当前日期区间的值，格式为 2017-08-01 ~ 2017-08-08
            }
        },
        props: ['did'],
        watch: {
            'did' () {
                if (!this.did) {
                    return
                }
                this.tagSelected = '全部'
                this.showDateAndStarFilter = true
                this.commentDateSelected = ''
                this.commentStarSelected = ['1', '2', '3', '4', '5']
                this.commentDateRange = ''
                this.getTagsData(this.did, '1')
                eventBus.$emit('getDataForReply', { did: this.did, channel: this.channel, replyType: 1 })
            }
        },
        methods: {
            // 切换平台
            changeChannel (e) {
                const ev = e.target
                if (ev.tagName === 'SPAN') {
                    const channel = ev.dataset.channel
                    this.channel = channel
                    this.tagSelected = '全部'
                    this.showDateAndStarFilter = true
                    this.commentDateSelected = ''
                    this.commentStarSelected = ['1', '2', '3', '4', '5']
                    this.commentDateRange = ''
                    eventBus.$emit('getDataForReply', { did: this.did, channel: this.channel, replyType: 1 })
                } else {
                    return
                }
            },

            // 点击标签
            changeTag (e) {
                const ev = e.target
                if (ev.tagName === 'SPAN') {
                    const tag = ev.dataset.tag
                    if (this.tagSelected === tag) {
                        return
                    }
                    this.tagSelected = tag
                    if (this.tagSelected === '全部') {
                        // 全部状态下，显示日期和星级筛选
                        this.showDateAndStarFilter = true
                        this.commentDateSelected = ''
                        this.commentStarSelected = ['1', '2', '3', '4', '5']
                        this.commentDateRange = ''
                        eventBus.$emit('getDataForReply', { did: this.did, channel: this.channel, replyType: 1 })
                    } else if (this.tagSelected === '30天未回复') {
                        this.showDateAndStarFilter = false
                        eventBus.$emit('getDataForReply', { did: this.did, channel: this.channel, replyType: 2 })
                    } else if (this.tagSelected === '有内容评价') {
                        this.showDateAndStarFilter = false
                        eventBus.$emit('getDataForContent', { did: this.did, contentType: 1 })
                    } else {
                        this.showDateAndStarFilter = false
                        eventBus.$emit('getDataForTags', { did: this.did, channel: this.channel, tag: this.tagSelected })
                    }
                } else {
                    return
                }
            },

            // 选择评价星级，至少保证一个选中状态
            selectCommentStar (value) {
                const k = this.commentStarSelected.indexOf(value)
                const len = this.commentStarSelected.length
                if (k !== -1) {
                    if (len > 1) {
                        this.commentStarSelected.splice(k, 1)
                        this.getCommentData()
                    } else {
                        return
                    }
                } else {
                    this.commentStarSelected.push(value)
                    this.getCommentData()
                }
            },

            // 选择评价日期
            selectCommentDate (value) {
                if (value === this.commentDateSelected && value !== 'range') {
                    return
                }
                this.commentDateSelected = value
                if (this.commentDateSelected === 'range') {
                    return
                } else {
                    this.getCommentData()
                }
            },

            // 请求筛选返回的数据
            getCommentData () {
                let startDate = ''
                let endDate = ''
                const starLevels = this.commentStarSelected.join(',')
                switch (this.commentDateSelected) {
                    case '0': startDate = Moment().format('YYYY-MM-DD')
                        endDate = Moment().format('YYYY-MM-DD')
                        break
                    case '1': startDate = Moment().subtract(Moment.duration(1, 'd')).format('YYYY-MM-DD')
                        endDate = Moment().subtract(Moment.duration(1, 'd')).format('YYYY-MM-DD')
                        break
                    case '2': startDate = Moment().subtract(Moment.duration(6, 'd')).format('YYYY-MM-DD')
                        endDate = Moment().format('YYYY-MM-DD')
                        break
                    case '3': startDate = Moment().subtract(Moment.duration(29, 'd')).format('YYYY-MM-DD')
                        endDate = Moment().format('YYYY-MM-DD')
                        break
                    case 'range': const arr = this.commentDateRange.indexOf('~') !== -1 ? this.commentDateRange.split(' ~ ') : ['', '']
                        startDate = arr[0]
                        endDate = arr[1]
                        break
                }
                eventBus.$emit('getDataForOthers', { did: this.did, channel: this.channel, startDate: startDate, endDate: endDate, starLevels: starLevels })
            },

            // 获取标签数据
            getTagsData (did, channel) {
                if (!did || !channel) {
                    return
                }
                Comment.getTags(did, channel)
                    .then((res) => {
                        this.channelData[channel].score = res.data.score
                        this.channelData[channel].tags = res.data.reviewTags
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Filter.vue?9eb473fa